import { serializable, primitive } from 'serializr';

export class CompanyType {
  @serializable(primitive())
  id?: number;

  @serializable(primitive())
  name?: string;
}
